/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { get } from '../../../services/GenesisApi';
import { IAdjacentTSO } from '../../../types/AdjacentTSO.type';
import { GET_ADJACENT_TSO } from '../../../constants/AdjacentTSO';

export const getAdjacentTSO = createAsyncThunk(
  'adjacentTSO/getAdjacentTSO',
  async () => {
    return get(GET_ADJACENT_TSO, {})
      .then((response) => {
        return response.data || [];
      })
      .catch((error) => {
        throw error;
      });
  }
);

export interface IAdjacentTSOState {
  adjacentTSO: IAdjacentTSO[];
  loading: boolean;
}

export const initialState: IAdjacentTSOState = {
  adjacentTSO: [],
  loading: false,
};

const adjacentTSO = createSlice({
  name: 'adjacentTSO',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdjacentTSO.pending, (state: IAdjacentTSOState) => {
        state.loading = true;
        state.adjacentTSO = [];
      })
      .addCase(
        getAdjacentTSO.fulfilled,
        (
          state: IAdjacentTSOState,
          { payload }: PayloadAction<IAdjacentTSO[]>
        ) => {
          state.adjacentTSO = payload;
          state.loading = false;
        }
      )
      .addCase(getAdjacentTSO.rejected, (state: IAdjacentTSOState) => {
        state.loading = false;
      });
  },
});

export const adjacentTSOActions = adjacentTSO.actions;
export default adjacentTSO.reducer;
